import { PATH } from '@/constants/path';
import { apiCaller } from '@/redux/query';
import { Button, ButtonGroup, Frame, Link, Page, PageProps } from '@shopify/polaris';
import { AdjustIcon, BookIcon, ChartVerticalFilledIcon, DataTableIcon, FormsIcon, HomeIcon } from '@shopify/polaris-icons';
import { memo, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import RegularText from '../RegularText';
import Toast from '../Toast/Toast';
import { LayoutStyled } from './styled';
import ModalReview from '@/components/ModalReview';
import { LINKS } from '@/constants';

const appId = process.env.REACT_APP_BE_APP_ID;

const btnGroup = [
  {
    content: 'Home',
    icon: HomeIcon,
    path: PATH.DEFAULT,
  },
  {
    content: 'Chat widget',
    icon: AdjustIcon,
    path: PATH.WIDGETS,
  },
  {
    content: 'Analytics',
    icon: ChartVerticalFilledIcon,
    path: PATH.ANALYTICS,
  },
  {
    content: 'Contact form',
    icon: FormsIcon,
    path: PATH.CONTACT_FORM,
  },
  {
    content: 'Form answer',
    icon: DataTableIcon,
    path: PATH.FORM_ANSWER,
  },
  // {
  //   content: 'Pricing plan',
  //   icon: PlanIcon,
  // },
];

interface ILayoutProps extends PageProps {
  headers?: React.ReactNode;
}

const Layout = ({ ...props }: ILayoutProps): JSX.Element => {
  const location = useLocation();
  const navigate = useNavigate();
  const { data: dataSetting } = apiCaller.useGeneralSettingsQuery();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <LayoutStyled>
      <Frame>
        <Toast />

        <div className="nav-bar">
          <ButtonGroup fullWidth gap="extraTight">
            {btnGroup.map((item, index) => {
              if (item.path)
                return (
                  <Button
                    key={index}
                    icon={item.icon}
                    variant={
                      location.pathname === item.path.pathname || (index === 0 && location.pathname === '/')
                        ? 'primary'
                        : undefined
                    }
                    onClick={() => {
                      navigate({
                        ...item.path,
                      });
                    }}
                  >
                    {item.content}
                  </Button>
                );

              return (
                <Button
                  key={index}
                  icon={item.icon}
                  onClick={() => {
                    window.open(`https://www.wix.com/apps/upgrade/${appId}?appInstanceId=${dataSetting?.data?.instanceId}`);
                  }}
                >
                  {item.content}
                </Button>
              );
            })}
            <Button
              icon={BookIcon}
              onClick={() => {
                window.open('https://help.omegatheme.com/en/category/omega-messenger-whatsapp-chat-1n5rgs8/', '_blank');
              }}
            >
              Documentation
            </Button>
          </ButtonGroup>
        </div>
        {props.headers || null}
        <Page {...props}>
          <div>
            <div>{props.children}</div>
            <RegularText>
              <div className="layout-footer">
                <RegularText>
                  Share your experience with EDD here{' '}
                  <Link external url={LINKS.WIX_REVIEW}>
                    leave a review
                  </Link>
                </RegularText>
              </div>
            </RegularText>
            {/* <RegularText>
              <div className="layout-footer">
                Need help? Please view&nbsp;{' '}
                <Link
                  removeUnderline
                  target="_blank"
                  url="https://help.omegatheme.com/en/category/omega-messenger-whatsapp-chat-1n5rgs8/"
                >
                  our documentation guidelines.
                </Link>
              </div>
            </RegularText> */}
          </div>
        </Page>
      </Frame>
      <ModalReview />
    </LayoutStyled>
  );
};
export default memo(Layout);
